import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import GuestUserPop from '@/components/guest-user-pop/guest-user-pop';
import DrilldownStrugglePullup from '@/components/pull-up/drilldown-struggle-pullup/drilldown-struggle-pullup';
import { StruggleData } from '@/models/groups/report';

@Component({
    name: 'learning-challenge',
    components: {
        'guest-popup': GuestUserPop,
        'struggle-pullup': DrilldownStrugglePullup,
    },
})

export default class LearningChallenge extends Vue {

    // --------------------------------------------------------------------------------
    // Properties

    @Prop()
    private learningReportData!: any;
    @Prop()
    private isLearningChallenge?: boolean;
    @Prop()
    private isTenant?: boolean;
    @Prop()
    private isDemoTenant!: boolean;
    @Prop()
    private hiddenData?: boolean;
    @Prop()
    private selectedSubject: any;
    @Prop()
    private groupType!: string;
    @Prop()
    private isLoading!: boolean;
    @Prop()
    private parentGroupName!: any;

    @Prop()
    private subjectList?: any;

    private get isGuestUser() {
        return this.$access.isGuestUser('guest', 'guest');
    }

    private isGuestPullup: boolean = false;

    private isShowPullup: boolean = false;

    @Prop()
    private isAtInitialLevel!: boolean;

   @Prop()
   private groupLabel: any;

   @Prop()
   private groupName: any;
    // ------------------------------------------------------------------------
    // Hooks

    // -------------------------------------------------------------------------------
    // Actions
    private onShowPopup() {
        if (this.isGuestUser) {
            this.isGuestPullup = true;
            return;
        }
        if (
                 this.learningReportData.length && !this.$access.isDemoGroup) {
            const activeSubject = this.selectedSubject ? this.selectedSubject : null;
            this.isShowPullup = true;
        }
    }

    private onCloseTsPullup() {
        this.isGuestPullup = false;
        this.isShowPullup = false;
    }

    private onSelectStrunggleSubject(subject: any = null) {
        this.$emit('onSelectStrunggleSubject', subject);
    }

    private onSelectLevel(level: any, subject: any, cardName: string) {
        this.$emit('onSelectLevel', level, subject, cardName);
    }
    // -------------------------------------------------------------------------------
    // Methods


}
